import { getFullName } from "Messenger/pages/TeamConversation/utils";
import constants from "../../constants";
import DirectCallMain from "Messenger/calling/DirectCallMain/DirectCallMain";
import SbCallsProvider from "Messenger/calling/sendbird-calls/SbCallsContext/provider";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import SendbirdProvider from "@sendbird/uikit-react/SendbirdProvider";
import SendbirdNotificationRuntime from "Messenger/components/SendbirdNotificationRuntime";

export const chatNotEnabled = [
  constants.systemRoles.superAdmin,
  constants.systemRoles.vendor,
  constants.systemRoles.staff,
];

/** Keep the WebSocket alive in a hidden tab so in-app toasts still work. Closed-tab FCM uses setBackgroundState on unload instead. */
const SENDBIRD_SDK_INIT_PARAMS = { appStateToggleEnabled: false };

const SenbirdChatCallWrapper = ({ children, t }) => {
  const profile = useSelector((state) => state.userProfile.profile);
  const incomingCall = useMemo(() => {
    return profile?.role?.systemRole === constants.systemRoles.patient;
  }, [profile?.role?.systemRole]);

  const isVendor =
    profile?.role?.systemRole === constants.systemRoles.vendor;
  const nickname =
    getFullName(profile) || profile?.businessName || `${profile?.id || ""}`;

  if (
    !profile?.id ||
    !profile?.role?.systemRole ||
    (!isVendor &&
      chatNotEnabled.includes(profile?.role?.systemRole) &&
      !profile?.isPatientChat &&
      !profile?.isMessenger)
  ) {
    return children;
  }

  const provider = (
    <SendbirdProvider
      appId={process.env.REACT_APP_SENDBIRD_APP_ID}
      userId={`${profile.id}`}
      nickname={nickname}
      profileUrl={profile.profilePic || null}
      sdkInitParams={SENDBIRD_SDK_INIT_PARAMS}
      uikitOptions={{
        groupChannel: {
          enableMention: false,
          enableReactions: true,
          enableReactionsSupergroup: true,
        },
      }}
    >
      {isVendor ? (
        <SendbirdNotificationRuntime>{children}</SendbirdNotificationRuntime>
      ) : (
        <SbCallsProvider t={t}>
          {incomingCall && <DirectCallMain dial={false} />}
          {children}
        </SbCallsProvider>
      )}
    </SendbirdProvider>
  );

  return provider;
};

export default SenbirdChatCallWrapper;
